import { Component, OnInit } from '@angular/core';
import { CandidateJobsService } from 'src/app/shared';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-joblog',
  templateUrl: './joblog.component.html',
  styleUrls: ['./joblog.component.scss']
})
export class JoblogComponent implements OnInit {

 
  id: any = "";
  logs: any = [];

  constructor(private actionService: CandidateJobsService,
    private activateRoute : ActivatedRoute,
    private router: Router
    ) { }

  ngOnInit() {
    this.activateRoute.paramMap.subscribe (p =>{
      this.id = p.get("id");
      this.loadAll ();
    });
    
  }

  loadAll (){
    this.actionService.getLogs (this.id, {})
    .subscribe (r=>{
      this.logs  = r;
    }); 
  }

}
